import React, { useEffect, useState, useRef } from "react"
import PropTypes from 'prop-types'
import {
	Button,
	Card,
	CardBody,
	Col,
	Container,
	Row,
} from "reactstrap"
import moment from "moment"
import { useRouteMatch, useHistory,Link } from "react-router-dom"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { CheckPicker } from 'rsuite'
import Loader from "../../../components/Loader/Loader"
import { Dropdown } from "react-bootstrap"
import { GoKebabVertical } from 'react-icons/go'
//Helpers
import isValidUrl from "../../../helpers/url_checker"
//GraphQL
import { MerchantProductList } from "gql/query"
import { useQuery } from "@apollo/client"

const Promotions = (props) => {

 	
	const history = useHistory()
	const [products, setProducts] = useState([])
	const FormatData = (data) => {
 		const Promotions = data.map(elem => {
			
			return {
				 ...elem?.promotion,
			}
		})
 		return Promotions
	}

	const columns = [
		{
			text: "Id",
			dataField: "id",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Code",
			dataField: "code",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Max Item Count",
			dataField: "max_item_count",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Max Order Amount",
			dataField: "max_order_amount",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
 
		{
			text: "Max Order Count",
			dataField: "max_order_count",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},

		{
			text: "Min Item Count",
			dataField: "min_item_count",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Min Order Amount",
			dataField: "min_order_amount",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Min Order Count",
			dataField: "min_order_count",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},

		{
			text: "Promoted By",
			dataField: "promoted_by",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},


		{
			text: "Usable Count",
			dataField: "usable_count",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Used Count",
			dataField: "used_count",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Valid From",
			dataField: "valid_from",
			sort: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Valid Till",
			dataField: "valid_till",
			sort: true,
			// eslint-disable-next-line react/display-name
		},

		{
			text: "Value",
			dataField: "value",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},

				{
			text: "Value Type",
			dataField: "value_type",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},

		{
			text: "Active",
			dataField: "active",
			sort: true,
			formatter: (cellContent, row) => row?.price_includes_tax ? "True":"False" 
			 
		},
		{
			text: "Apply Delivery Charges",
			dataField: "apply_on_delivery_charge",
			sort: true,
			formatter: (cellContent, row) => row?.apply_on_delivery_charge ? "True":"False" 
			 
		},
		{
			text: "Apply on Parcel Charges",
			dataField: "apply_on_parcel_charge",
			sort: true,
			formatter: (cellContent, row) => row?.apply_on_parcel_charge ? "True":"False" 
			 
		},
		
		{
			text: "Before Tax",
			dataField: "before_tax",
			sort: true,
			formatter: (cellContent, row) => row?.before_tax ? "True":"False" 
			 
		},
		{
			text: "Cashback",
			dataField: "cashback",
			sort: true,
			formatter: (cellContent, row) => row?.cashback ? "True":"False" 
			 
		},
    
		// {
		// 	dataField: "view",
		// 	isDummyField: true,
		// 	text: "Action",
		// 	sort: false,
		// 	// eslint-disable-next-line react/display-name
		// 	formatter: (cellContent, row) => (
		// 	  <Dropdown>
		// 		<Dropdown.Toggle variant="transparent" id="dropdown-basic">
		// 		  <GoKebabVertical />
		// 		</Dropdown.Toggle>
		// 		<Dropdown.Menu>
		// 		  <Dropdown.Item onClick={() => history.push(`/ecommerce-products/detail/${row.product_id}`)}>View Details</Dropdown.Item>
		// 		</Dropdown.Menu>
		// 	  </Dropdown>
		// 	),
		//   },
	]
	const defaultSorted = []
	useEffect(() => {
		if (props.data) {
			setProducts(FormatData(props.data))
		}
	}, [props.data])
	
	return (
		<div className="p-3">
			<Row className="mb-5">
				<Row className="mb-2">
					<Col sm="8">
						{props.showLabel && (
							<h4>{props.label}</h4>
						)}
					</Col>
					<Col sm="4">
						<div className="text-sm-end d-flex justify-content-end">
							
						</div>
					</Col>
				</Row>
				<hr />
				<ToolkitProvider
					keyField="id"
					data={products || []}
					columns={columns}
					bootstrap4
				// search
				>
					{toolkitProps => (
						<>
							<Row>
								<Col xl="12">
									<div className="table-responsive">
										{false ? <Loader /> :
											<BootstrapTable
												responsive
												bordered={false}
												striped={false}
												defaultSorted={defaultSorted}
												classes={"table align-middle table-nowrap"}
												keyField="id"
												{...toolkitProps.baseProps}
												onTableChange={() => { }}
												noDataIndication={() => "No Products Found!"}
											// {...paginationTableProps}
											/>
										}
									</div>
								</Col>
							</Row>
						</>
					)}
				</ToolkitProvider>
			</Row>
		</div>
	)
}
Promotions.propTypes = {
	order: PropTypes.any,
	showLabel: PropTypes.bool,
	label: PropTypes.string,
	data: PropTypes.any,
}
Promotions.displayName = 'Promotions'
export default Promotions